import { render, staticRenderFns } from "./DialogTenderSend.vue?vue&type=template&id=3692cc8e"
import script from "./DialogTenderSend.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogTenderSend.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports